import React, { useState } from 'react';
import { styled } from "../../../stitches.config";
import useMediaQuery from "../../../helpers/useMediaQuery";
import Link from "../../Link"
import ArrowDown from "../../../redesign/assets/icons/arrow-down-white.svg"


const PregnancyCalendar = (props) => {
    const isDesktop = useMediaQuery('bp4');

    const [activeBox1, setActiveBox1] = useState(false);
    const [activeBox2, setActiveBox2] = useState(false);
    const [activeBox3, setActiveBox3] = useState(false);

    // links 

    const weekLinks = [
        { number: 1, url: "https://mamadu.pl/135815,1-tydzien-ciazy-kalendarz-ciazy" },
        { number: 2, url: "https://mamadu.pl/135759,2-tydzien-ciazy-kalendarz-ciazy" },
        { number: 3, url: "https://mamadu.pl/135829,3-tydzien-ciazy-kalendarz-ciazy" },
        { number: 4, url: "https://mamadu.pl/135749,4-tydzien-ciazy-kalendarz-ciazy" },
        { number: 5, url: "https://mamadu.pl/135753,5-tydzien-ciazy-kalendarz-ciazy" },
        { number: 6, url: "https://mamadu.pl/135721,6-tydzien-ciazy-kalendarz-ciazy" },
        { number: 7, url: "https://mamadu.pl/135735,7-tydzien-ciazy-kalendarz-ciazy" },
        { number: 8, url: "https://mamadu.pl/135709,8-tydzien-ciazy-kalendarz-ciazy" },
        { number: 9, url: "https://mamadu.pl/135727,9-tydzien-ciazy-kalendarz-ciazy" },
        { number: 10, url: "https://mamadu.pl/135565,10-tydzien-ciazy-kalendarz-ciazy" },
        { number: 11, url: "https://mamadu.pl/135575,11-tydzien-ciazy-kalendarz-ciazy" },
        { number: 12, url: "https://mamadu.pl/135583,12-tydzien-ciazy-kalendarz-ciazy" },
        { number: 13, url: "https://mamadu.pl/135397,13-tydzien-ciazy-kalendarz-ciazy" },
        { number: 14, url: "https://mamadu.pl/135411,14-tydzien-ciazy-kalendarz-ciazy" },
        { number: 15, url: "https://mamadu.pl/135419,15-tydzien-ciazy-kalendarz-ciazy" },
        { number: 16, url: "https://mamadu.pl/135553,16-tydzien-ciazy-kalendarz-ciazy" },
        { number: 17, url: "https://mamadu.pl/135473,17-tydzien-ciazy-kalendarz-ciazy" },
        { number: 18, url: "https://mamadu.pl/135513,18-tydzien-ciazy-kalendarz-ciazy" },
        { number: 19, url: "https://mamadu.pl/135437,19-tydzien-ciazy-kalendarz-ciazy" },
        { number: 20, url: "https://mamadu.pl/135447,20-tydzien-kalendarz-ciazy" },
        { number: 21, url: "https://mamadu.pl/135459,21-tydzien-ciazy-kalendarz-ciazy" },
        { number: 22, url: "https://mamadu.pl/135561,22-tydzien-ciazy-kalendarz-ciazy" },
        { number: 23, url: "https://mamadu.pl/135577,23-tydzien-ciazy-kalendarz-ciazy" },
        { number: 24, url: "https://mamadu.pl/135521,24-tydzien-ciazy-kalendarz-ciazy" },
        { number: 25, url: "https://mamadu.pl/135533,25-tydzien-ciazy-kalendarz-ciazy" },
        { number: 26, url: "https://mamadu.pl/135597,26-tydzien-ciazy-kalendarz-ciazy" },
        { number: 27, url: "https://mamadu.pl/135599,27-tydzien-ciazy-kalendarz-ciazy" },
        { number: 28, url: "https://mamadu.pl/135621,28-tydzien-ciazy-kalendarz-ciazy" },
        { number: 29, url: "https://mamadu.pl/135611,29-tydzien-ciazy-kalendarz-ciazy" },
        { number: 30, url: "https://mamadu.pl/135619,30-tydzien-ciazy-kalendarz-ciazy" },
        { number: 31, url: "https://mamadu.pl/135625,31-tydzien-ciazy-kalendarz-ciazy" },
        { number: 32, url: "https://mamadu.pl/135643,32-tydzien-ciazy-kalendarz-ciazy" },
        { number: 33, url: "https://mamadu.pl/135661,33-tydzien-ciazy-kalendarz-ciazy" },
        { number: 34, url: "https://mamadu.pl/135671,34-tydzien-ciazy-kalendarz-ciazy" },
        { number: 35, url: "https://mamadu.pl/135679,35-tydzien-ciazy-kalendarz-ciazy" },
        { number: 36, url: "https://mamadu.pl/135689,36-tydzien-ciazy-kalendarz-ciazy" },
        { number: 37, url: "https://mamadu.pl/135699,37-tydzien-ciazy-kalendarz-ciazy" },
        { number: 38, url: "https://mamadu.pl/135697,38-tydzien-ciazy-kalendarz-ciazy" },
        { number: 39, url: "https://mamadu.pl/135707,39-tydzien-kalendarz-ciazy" },
        { number: 40, url: "https://mamadu.pl/135807,40-tydzien-ciazy-kalendarz-ciazy" },
    ]

    const firstTrimester = weekLinks.slice(0, 13);
    const secondTrimester = weekLinks.slice(13, 27);
    const thirdTrimester = weekLinks.slice(27, 40);

    return (
        <Wrapper>
            <section className="container">
                <Title>Śledź zachodzące zmiany z mamadu tydzień po tygodniu</Title>
                <Box>
                    <BoxHeader onClick={() => setActiveBox1(!activeBox1)}>1 trymestr ciąży<span className={activeBox1 ? "rotate" : ""} /></BoxHeader>
                    <BoxLinks className={isDesktop || activeBox1 ? "active" : ""}>
                        {firstTrimester.map((week, index) =>
                            <Link key={index} to={week.url}>{week.number}</Link>
                        )}
                    </BoxLinks>
                </Box>
                <Box>
                    <BoxHeader onClick={() => setActiveBox2(!activeBox2)}>2 trymestr ciąży<span className={activeBox2 ? "rotate" : ""} /></BoxHeader>
                    <BoxLinks className={isDesktop || activeBox2 ? "active" : ""}>
                        {secondTrimester.map((week, index) =>
                            <Link key={index} to={week.url}>{week.number}</Link>
                        )}
                    </BoxLinks>
                </Box>
                <Box>
                    <BoxHeader onClick={() => setActiveBox3(!activeBox3)}>3 trymestr ciąży<span className={activeBox3 ? "rotate" : ""} /></BoxHeader>
                    <BoxLinks className={isDesktop || activeBox3 ? "active" : ""}>
                        {thirdTrimester.map((week, index) =>
                            <Link key={index} to={week.url}>{week.number}</Link>
                        )}
                    </BoxLinks>
                </Box>
            </section>
        </Wrapper>
    );
};

const Title = styled('div', {
    width: "100%",
    fontSize: "24px",
    lineHeight: "29px",
    fontWeight: "bold",
    color: "$grayscale100",
    marginBottom: "32px",
    "@bp4": {
        marginBottom: "0px",
        maxWidth: "338px",
        fontSize: "38px",
        lineHeight: "45px",
    },
});

const Wrapper = styled('div', {
    marginBottom: "70px",

    "& .container": {
        "@bp4": {
            display: "flex",
            justifyContent: "space-between",
        }
    }
});

const Box = styled('div', {
    width: "100%",
    maxWidth: "278px",
    margin: "11px auto 0 auto",
    "@bp3": {
        maxWidth: "auto",
    },
    "@bp4": {
        maxWidth: "278px",
        margin: "0 auto",
    },

    "& .active": {
        display: "flex",
    },
    "& .rotate": {
        transform: "rotate(180deg)"
    }
});

const BoxHeader = styled('div', {
    background: "$grayscale100",
    color: "$grayscale0",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "48px",
    cursor: "pointer",
    position: "relative",
    "@bp4": {
        cursor: "default",
    },
    "& span": {
        position: "absolute",
        right: "20px",
        top: "20px",
        width: "16px",
        height: "8px",
        backgroundImage: `url("${ArrowDown}")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        "@bp4": {
            display: "none",
        }
    }
});

const BoxLinks = styled('div', {
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    marginBottom: "18px",
    padding: "16px 19px 16px 19px",
    display: "none",
    "@bp4": {
        padding: "16px 19px 0 19px",
    },

    "& a": {
        fontSize: "16px",
        color: "$grayscale0",
        background: "$grayscale100",
        width: "48px",
        height: "48px",
        borderRadius: "48px",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "0.3s",
        margin: "0px 6px 9px 6px",
        "&:hover": {
            textDecoration: "none",
            color: "$grayscale0",
            background: "$primary",
        }
    }
});


export default PregnancyCalendar;